import http from "../utils/http"

/**
 * รายการของแพคเกจคําสั่งผสม
 * @param {object} params
 */
export function bundlingList(params) {
    return http({
        url: "/bundling/api/bundling/lists",
        data: params
    })
}
